"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$articleLine = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const _articleTitle_1 = __importDefault(require("./$articleTitle"));
const _sentencesArray_1 = __importDefault(require("./$sentencesArray"));
const makeRangesRule_1 = __importDefault(require("./makeRangesRule"));
const { $ranges: $articleRanges } = (0, makeRangesRule_1.default)(() => _articleTitle_1.default);
/**
 * The parser rule for {@link ArticleLine} that represents a first line of an article. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$articleLine.spec.ts) for examples.
 */
exports.$articleLine = factory_1.default
    .withName("articleLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .sequence(s => s
    .and(() => $articleRanges, "title")
    .action(({ title, text }) => {
    return {
        value: text(),
        errors: title.errors,
    };
})), "title")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(c => c
    .and(() => lexical_1.$__, "midSpace")
    .and(() => _sentencesArray_1.default, "columns")
    .action(({ midSpace, columns }) => {
    return { midSpace, columns };
}))), "contentStruct")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, title, contentStruct, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...title.errors,
        ...(contentStruct?.columns.errors ?? []),
    ];
    return {
        value: new line_1.ArticleLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            title: title.value,
            midSpace: contentStruct?.midSpace ?? "",
            sentencesArray: contentStruct?.columns.value ?? [],
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$articleLine;
//# sourceMappingURL=$articleLine.js.map